<h3 id="header" class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="ui basic segment">
    <div class="name" appMargin marginB="20px" [innerHtml]="msg"></div>
    <div class="inline center aligned" style="margin-top: 20px">
      <button class="ui primary button" (click)="modal.approve()" autofocus>
        Okay
      </button>
    </div>
  </div>
</div>
